export const AUDIT_LOGS_SUPPORTED_SYSTEMS = [
  { name: 'CDP', label: 'Personalize / CDP' },
  { name: 'Connect', label: 'Connect' },
  { name: 'ContentService', label: 'Content Service' },
  { name: 'Identity', label: 'Cloud Portal' },
] as const;

export type AuditLogsSupportedSystemName =
  (typeof AUDIT_LOGS_SUPPORTED_SYSTEMS)[number]['name'];
